/* global axios */
import ApiClient from '../ApiClient';

// T-291: presença do agente. Entrada e saída do turno por dia, e tempo em cada estado.
class PresencaRelatorioAPI extends ApiClient {
  constructor() {
    super('fandata/presenca_relatorio', { accountScoped: true });
  }

  get({ since, until } = {}) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new PresencaRelatorioAPI();
